import { useQuery } from "@tanstack/react-query";
import { getDepositBonus, getManualDeposits, getPromotionsBanner, getCampaigns } from "../api/promotionsApi";

export const useDepositBonusQuery = () => {
  return useQuery({
    queryKey: ["depositBonus"],
    queryFn: getDepositBonus,
    refetchOnWindowFocus: false,
  });
};

export const useManualDepositsQuery = (uid) => {
  return useQuery({
    queryKey: ["manualDeposits", uid],
    queryFn: () => getManualDeposits({ uid }),
    enabled: !!uid,
    refetchOnWindowFocus: false,
  });
};

export const usePromotionsBannerQuery = (type = 'promotions') => {
  return useQuery({
    queryKey: ["promotionsBanner", type],
    queryFn: () => getPromotionsBanner(type),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useCampaignsQuery = (showOn) => {
  return useQuery({
    queryKey: ["campaigns", showOn],
    queryFn: () => getCampaigns(showOn),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
